<template>
  <div class="w-full min-h-screen flex flex-col">
    <MainNav />
    <section class="w-full relative">
      <!-- Keep the hero section for now, consider changing image/title later -->
      <img 
        src="/image/83islands_sugarcane.jpg" 
        alt="83 Islands Jungle" 
        class="w-full h-[800px] object-cover object-[bottom_center] md:object-center"
      />
      
      <!-- Text Overlay -->
      <div class="mx-auto absolute mt-36 inset-0 z-20 w-full p-4 lg:p-36 flex flex-col items-center lg:items-start pointer-events-none">
        <h1 class="text-white font-maax text-4xl uppercase lg:text-6xl font-bold text-center lg:text-left max-w-3xl leading-tight drop-shadow-[0_5px_5px_rgba(0,0,0,0.3)] pointer-events-auto">
          Welcome, {{ companyName }} Partners!
        </h1>
      </div>

      <!-- Double Wave -->
      <div class="absolute -bottom-1 left-0 right-0 w-full overflow-hidden">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" class="w-full h-20 text-white">
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" 
                fill="currentColor" class="opacity-25"/>
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" 
                fill="currentColor"/>
        </svg>
      </div>
    </section>

    <main class="flex-grow w-full bg-white">
      <div class="container mx-auto p-4 py-12">
        <div class="max-w-4xl mx-auto">
          <h2 class="text-4xl font-maax font-bold uppercase text-black pb-4 text-center lg:text-left">
            Operator Program: {{ companyName }}
          </h2>

          <p class="font-maax text-black text-xl pb-8">
            83 Islands is a leader in Guest experience in Port Vila. Join our Tour Operator Program to have access to better deals for you and your clients, check our schedule, request after-hours tours or private events.
          </p>
          
          <!-- Add more operator-specific content, forms, schedules, etc. here -->
          <p class="font-maax text-black text-xl pb-8">
            [Placeholder for schedule information]
          </p>
          <p class="font-maax text-black text-xl pb-8">
            [Placeholder for booking/request forms]
          </p>
        </div>
      </div>
    </main>
    <Footer class="relative" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import MainNav from '../components/MainNav.vue';
import Footer from '../components/Footer.vue';

const route = useRoute();

// Get the company name from the route parameters
const companyName = computed(() => {
  // Basic capitalization, adjust formatting as needed
  const name = route.params.companyName || 'Valued Partner';
  return name.charAt(0).toUpperCase() + name.slice(1);
});

// Removed scroll handling logic from Spirits.vue as it might not be needed here
// Add back if header behavior is desired
</script>

<style>
/* Styles copied from Spirits.vue, keep or remove as needed */
header {
    transition: transform 0.3s ease;
}
</style> 